var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.833 9.75L10 2.25l9.167 7.5M8.333 19.75v-5h3.334v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 11.417v8.333h13.334v-8.333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGrey);
export default __webpack_public_path__ + "static/media/home-grey.5d5d1334148e0389e57ca66656b121b5.svg";
export { ForwardRef as ReactComponent };